import { ApiCreateBrand, ApiDeleteBrand, ApiGetBrandList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function BrandService() {
    const { showFail } = useModal()

    const { fetch: apiGetBrandList } = useFetch(ApiGetBrandList)
    const { fetch: apiDeleteBrand } = useFetch(ApiDeleteBrand)
    const { fetch: apiCreateBrand } = useFetch(ApiCreateBrand)

    const fetchBrandList = async(brandName, status, pageSize, index) => {
        const res =  await apiGetBrandList({
            data: {
                brandName, 
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteBrand = async(brandId, status) => {
        const res =  await apiDeleteBrand({
            data: {
                brandId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateBrand = async(brandName) => {
        const res = await apiCreateBrand({
            data: {
                brandName
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchBrandList,
        fetchDeleteBrand,
        fetchCreateBrand 
    }
}